import { render, staticRenderFns } from "./ValidationProvider.vue?vue&type=template&id=2c5c4640"
import script from "./ValidationProvider.vue?vue&type=script&lang=js"
export * from "./ValidationProvider.vue?vue&type=script&lang=js"
import style0 from "./ValidationProvider.vue?vue&type=style&index=0&id=2c5c4640&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports